// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background-color: #011029;
  z-index: 1000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.navbar {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  width: 100%;
}

.logo {
  margin-right: auto;
}

.logo a {
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.3s ease;
}

.logo a:hover {
  color: #2980b9;
}

.menu-button {
  background: transparent;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;
  display: flex;
  justify-content: flex-end;
}

.menu-content {
  background-color: #011029;
  width: 300px;
  height: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.menu-content a {
  color: white;
  text-decoration: none;
  font-size: 1.1rem;
  padding: 0.5rem 0;
  transition: color 0.3s ease;
}

.menu-content a:hover,
.menu-content a.active {
  color: #2980b9;
}

.menu-footer {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.welcome-text {
  color: white;
  font-size: 0.9rem;
  opacity: 0.8;
}

.logout-button {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.logout-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.login-button {
  background: #2980b9;
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.login-button:hover {
  background: #3498db;
} `, "",{"version":3,"sources":["webpack://./src/components/navbar/Navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 64px;\n  background-color: #011029;\n  z-index: 1000;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.navbar {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 2rem;\n  width: 100%;\n}\n\n.logo {\n  margin-right: auto;\n}\n\n.logo a {\n  color: #ffffff;\n  font-size: 1.5rem;\n  font-weight: bold;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.logo a:hover {\n  color: #2980b9;\n}\n\n.menu-button {\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.menu-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 999;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.menu-content {\n  background-color: #011029;\n  width: 300px;\n  height: 100%;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.menu-content a {\n  color: white;\n  text-decoration: none;\n  font-size: 1.1rem;\n  padding: 0.5rem 0;\n  transition: color 0.3s ease;\n}\n\n.menu-content a:hover,\n.menu-content a.active {\n  color: #2980b9;\n}\n\n.menu-footer {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.welcome-text {\n  color: white;\n  font-size: 0.9rem;\n  opacity: 0.8;\n}\n\n.logout-button {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n}\n\n.logout-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.login-button {\n  background: #2980b9;\n  color: white;\n  padding: 0.5rem 1.5rem;\n  border-radius: 4px;\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n\n.login-button:hover {\n  background: #3498db;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
